export const VERSAO = '0.1.9.1 | Build 1.19042023.4';
export const H_01_HORA = 3600000;
export const H_24_HORAS = H_01_HORA * 24;

export const PASSWORD_UPDATED = '@fila/passwordFilaUpdated'
